import axios from 'utils/axios';

export async function getOfficeLocations() {
    try {
        const response = await axios.get('/api/org-id/{orgId}/clinic-id/{clinicId}/office-location');
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            throw e;
        }
        throw new Error('unknown error');
    }
}

export async function getPatientAssignableOfficeLocations() {
    try {
        const response = await axios.get('/api/org-id/{orgId}/clinic-id/{clinicId}/patient-assignable-office-locations');
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            throw e;
        }
        throw new Error('unknown error');
    }
}

export async function createOfficeLocation(name) {
    try {
        const response = await axios.post('/api/org-id/{orgId}/clinic-id/{clinicId}/office-location', { name });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

// data may include { name } to rename and/or { archived } to archive/unarchive
export async function updateOfficeLocation(officeLocationId, data) {
    try {
        const response = await axios.post(`/api/org-id/{orgId}/clinic-id/{clinicId}/office-location/${officeLocationId}`, data);
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}
